import { render, staticRenderFns } from "./OverlayTutoList.vue?vue&type=template&id=64ef782e&scoped=true&"
import script from "./OverlayTutoList.vue?vue&type=script&lang=js&"
export * from "./OverlayTutoList.vue?vue&type=script&lang=js&"
import style0 from "./OverlayTutoList.vue?vue&type=style&index=0&id=64ef782e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef782e",
  null
  
)

export default component.exports